const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const AT = require("../vault/ActionTypes");
const withVaultUpdate = require("../hoc/withVaultUpdate");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const URLMake = require("../../../shared/URLMake");
const OpsChapterPath = require("../vault/OpsChapterPath");
const {
	atChapters,
	atDemo,
	atDemoData,
	atPageUser,
	atPage,
} = require("../vault/StateCursors");
const OpsUser = require("../vault/OpsUser");
const LoadGuard = require("../view/LoadGuard");
const LoadState = require("../vault/util/LoadState");
const TopBar = require("../view/TopBar");
const Sounds = require("../util/Sounds");
const AssetsUtil = require("../util/AssetsUtil");
const MessageModal = require("../view/MessageModal");
const CopyTable = require("../util/CopyTable");
const {shouldSimplifyNavigation} = require("../util/NavigationUtil");
const {PortalDestination} = require("../view/PortalDestination");
const {PORTAL_CONTAINERS} = require("../../../shared/PortalConstants");
const PageBackdrop = require("./PageBackdrop");
const PageHomeUtil = require("./util/PageHomeUtil");
const PlacementTestInviteModal = require("../view/PlacementTestInviteModal");

const PageHomeBuildings = require("./PageHomeBuildings");

const styles = require("./styles/PageHome.css");
const {InvalidUserForSchoolModal} = require("./InvalidUserForSchoolModal");

const getPropsFromVault = (props, vaultState) => {
	const user = atPageUser(vaultState).get();
	const chapters = atChapters(vaultState).get();
	const avatarChapterID = OpsChapterPath.getChapterIDForAvatar(vaultState);

	return {
		avatarChapterID,
		avatarChapterURL: OpsChapterPath.getChapterURLForAvatar(vaultState),
		chapters,
		demoData: atDemoData(vaultState).get() || LoadState.loadInit(),
		demoTutorialShown: atDemo(vaultState).getIn("showing"),
		user,
		page: atPage(vaultState).get(),
	};
};

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, getPropsFromVault);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "PageHome",

		propTypes: {
			errorMessageInfo: PT.object,
			demo: PT.bool,

			// Injected by HOCs
			avatarChapterID: PT.number,
			avatarChapterURL: PT.string,
			chapters: PT.object,
			demoData: PT.object,
			demoTutorialShown: PT.string,
			dispatch: PT.func.isRequired,
			user: PT.object.isRequired,
			page: PT.object.isRequired,
		},

		getInitialState: function() {
			return {
				isOfficeModalOpen: !this.canViewTrainer(),
				demoTutorialShown: null,
				isMessageModalOpen: false,
				showPlacementTestInviteModal: false,
			};
		},

		vaultEvents: {
			showPlacementTestInviteModal: function() {
				this.setState({showPlacementTestInviteModal: true});
			},
		},

		componentDidMount: function() {
			const canViewTrainer = this.canViewTrainer();
			const emi = this.props.errorMessageInfo;
			if (canViewTrainer) {
				Sounds.playMusic("main-menu");
			}
			if (emi && emi.messageType === "pageNotFound") {
				this.props.dispatch({
					type: AT.SHOW_MESSAGE,
					messageType: "pageNotFound",
					data: emi.notFound,
				});
			} else if (
				emi &&
				(emi.messageType === "testInProgress" ||
					emi.messageType === "bookTestInProgress")
			) {
				const data = _.extend(emi.data, {
					cannotClose: true,
				});
				this.props.dispatch({
					type: AT.SHOW_MESSAGE,
					messageType: emi.messageType,
					data,
				});
			} else if (emi) {
				this.props.dispatch(
					_.extend(
						{
							type: AT.SHOW_MESSAGE,
						},
						emi
					)
				);
			}
		},

		canViewTrainer: function() {
			const {user, demo} = this.props;
			const isStudent = OpsUser.hasStudentRole(user);
			const canPlay = OpsUser.hasTrainerPermission(user);
			return canPlay || isStudent || demo;
		},

		openMessageModal: function(space) {
			this.setState({isMessageModalOpen: true, space});
		},

		closeMessageModal: function() {
			this.setState({isMessageModalOpen: false});
		},

		makeButtonProps: function(
			space,
			buttonLocked,
			url,
			overrideClassName,
			options = {}
		) {
			const shouldSimplifyCampusView = shouldSimplifyNavigation(
				this.props.page
			);
			const className =
				overrideClassName ||
				styles[
					`${space}Button${
						space === "library" && shouldSimplifyCampusView ? "Simplified" : ""
					}`
				];

			return {
				className,
				handleClick: buttonLocked ? () => this.openMessageModal(space) : null,
				linkTo: buttonLocked ? null : url,
				buttonImageSrc: buttonLocked
					? AssetsUtil.getLockImage("white")
					: AssetsUtil.getButtonForSpace(space, "white"),
				buttonType: space,
				overrideBorderClass: buttonLocked ? styles.lockedLabBorder : null,
				overrideBGClass: buttonLocked ? styles.lockedLabBG : null,
				...options,
			};
		},

		getAvatarChapterStatus: function() {
			// no chapter to load if the user can't play
			if (!this.canViewTrainer()) return {load: "done"};
			if (this.props.demo) return this.props.demoData;

			const {chapters, avatarChapterID} = this.props;
			const chapter = _.get(chapters, avatarChapterID);
			if (!chapter) return {load: "none"};

			return chapter;
		},

		// loads the avatar's chapter
		loadAvatarChapter: function() {
			const {avatarChapterID} = this.props;
			this.loadChapter(avatarChapterID);
		},

		loadChapter: function(chapterID) {
			const {chapters, user} = this.props;
			const loadedChapterIDs = LoadState.filterByStatus(
				chapters,
				"done"
			).map(c => _.get(c, "chapterID"));
			if (loadedChapterIDs.includes(chapterID)) return;

			const {userID} = user;
			this.props.dispatch({
				type: AT.LOAD_CHAPTER_REQUEST,
				userID,
				chapterID,
			});
		},

		generateClassURL: function() {
			const {avatarChapterURL, user} = this.props;
			return avatarChapterURL ?? URLMake.forDefaultChapterPage(user);
		},

		renderHome: function() {
			const labURL = URLMake.forLabLobby();
			let classURL = URLMake.forChapterFromNumbers(3, 0);
			let libraryURL = URLMake.forLibraryFromNumbers(3);
			let theaterURL = URLMake.forTheaterFromNumbers(3, 0);
			const shouldSimplifyCampusView = shouldSimplifyNavigation(
				this.props.page
			);

			const user = this.props.user;
			if (this.props.demo) {
				classURL = URLMake.forDemoChapter();
				libraryURL = URLMake.forDemoLibraryGrade();
				theaterURL = URLMake.forDemoTheaterChapter();
			} else if (user.model) {
				classURL = this.generateClassURL();
				libraryURL = URLMake.forDefaultLibraryGrade(user);
				theaterURL = URLMake.forDefaultTheaterGrade(user);
			}

			let topBarEl;
			let modalEl;
			let labButtonProps = null;
			let libraryButtonProps = null;
			let classButtonProps = null;
			let theaterButtonProps = null;

			let labButtonLocked = true;

			const userViewedLibrary = _.get(
				user,
				["model", "activity", "hasSeenLibrary"],
				false
			);
			const userViewedTheater = _.get(
				user,
				["model", "activity", "hasSeenTheater"],
				false
			);

			// These are locked if the user has not read a book section or
			// watched a video, respectively
			// but we keep them unlocked for the demo and for school students
			// For the pathView/simplifyNavigation experiment, unlock the library by default.
			const isSchoolStudent = OpsUser.isSchoolStudent(user);
			const libraryButtonLocked =
				!userViewedLibrary &&
				!this.props.demo &&
				!isSchoolStudent &&
				!shouldSimplifyCampusView;
			const theaterButtonLocked = !userViewedTheater && !this.props.demo;

			if (!this.state.isOfficeModalOpen) {
				//We want the lab button to appear if we aren't in the demo
				const labButtonAppears = !this.props.demo;

				/**
				 * A student will normally unlock the lab upon reaching XP level 10,
				 * but this is overridden by parent/teacher settings or by being a dev.
				 * Typically, the lab would unlock when the user reaches XP
				 * level 10.  However, a class/teacher can manually unlock the lab,
				 * in which case user.model.labLockOverride will be "unlocked".
				 * A parent can also manually unlock the lab, in which case
				 * user.model.labProgressUnlocked will be true. Dev/admin accounts
				 * also have user.model.labProgressUnlocked set to true.
				 * For the pathView/simplifyNavigation experiment, unlock the lab by default.
				 */
				const unlockedByOverride =
					_.get(user, "model.labLockOverride") === "unlocked" ||
					shouldSimplifyCampusView;

				/**
				 * The lab button should only be unlocked if either of the following are true:
				 *   1. The school/class manually unlocked the lab, in which case this override always applies
				 *   2. The student satisfies the progress requirement (either by level or parent override)
				 */
				labButtonLocked = !(
					unlockedByOverride || _.get(user, "model.labProgressUnlocked")
				);

				let classButtonClassName = styles.classButton;
				if (this.props.demoTutorialShown === "home1stVisit") {
					classButtonClassName += " " + styles.demoHighlight;
				}

				libraryButtonProps = this.makeButtonProps(
					"library",
					libraryButtonLocked,
					libraryURL
				);
				theaterButtonProps = this.makeButtonProps(
					"theater",
					theaterButtonLocked,
					theaterURL
				);
				classButtonProps = this.makeButtonProps(
					"class",
					false,
					classURL,
					classButtonClassName
				);
				labButtonProps = labButtonAppears
					? this.makeButtonProps("lab", labButtonLocked, labURL, null, {
							buttonImageSize: 2,
					  })
					: null;

				topBarEl = (
					<div className={styles.pageTop}>
						<TopBar user={user} demo={this.props.demo} />
					</div>
				);
				if (this.state.isMessageModalOpen) {
					modalEl = (
						<MessageModal
							styleType="chapterPage"
							onClose={this.closeMessageModal}
							buttonType="ok"
						>
							{CopyTable.forSpaceProgressLocked(this.state.space)}
						</MessageModal>
					);
				}
			} else {
				modalEl = (
					<InvalidUserForSchoolModal
						user={user}
						redirectPage={this.redirectPage}
					/>
				);
			}

			const hoverTextTable = {
				theater: CopyTable.forSpaceProgressLocked("theater"),
				library: CopyTable.forSpaceProgressLocked("library"),
			};

			let hoverSize = "medium-wrap";
			if (this.props.demo) {
				hoverTextTable.lab = CopyTable.forLabInDemo();
				hoverSize = "large";
			} else if (!_.get(user, "model.labProgressUnlocked")) {
				hoverTextTable.lab = CopyTable.forSpaceProgressLocked("lab");
			}

			const makeBuildingProps = (
				space,
				locked,
				hoverDirection,
				buttonProps
			) => {
				const tooltipText = locked ? hoverTextTable[space] : null;
				return {
					tooltipText,
					tooltipSize: hoverSize,
					tooltipDirection: "top-" + hoverDirection,
					buttonProps,
				};
			};

			// Class building props made manually, as it won't have a tooltip
			// and has a different style
			const classStyles =
				styles.class +
				(this.props.demoTutorialShown === "home1stVisit"
					? " " + styles.demoHighlight
					: "");
			const classBuildingProps = {
				style: classStyles,
				...makeBuildingProps("class", false, "left", classButtonProps),
			};

			const labBuildingProps = makeBuildingProps(
				"lab",
				labButtonLocked,
				"right",
				labButtonProps
			);
			const theaterBuildingProps = shouldSimplifyCampusView
				? null
				: makeBuildingProps(
						"theater",
						theaterButtonLocked,
						"left",
						theaterButtonProps
				  );
			const libraryBuildingProps = makeBuildingProps(
				"library",
				libraryButtonLocked,
				"right",
				libraryButtonProps
			);

			return (
				<div className={styles.main}>
					{topBarEl}
					{modalEl}
					<PlacementTestInviteModal
						isOpen={this.state.showPlacementTestInviteModal}
						onClose={() => this.setState({showPlacementTestInviteModal: false})}
					/>
					<PortalDestination name={PORTAL_CONTAINERS.DEMO_TUTORIAL_MODAL} />
					<PageBackdrop
						images={PageHomeUtil.getBackdropImages()}
						imageStyles={styles}
						isSimplified={shouldSimplifyCampusView}
					/>
					<PageHomeBuildings
						labProps={labBuildingProps}
						classProps={classBuildingProps}
						theaterProps={theaterBuildingProps}
						libraryProps={libraryBuildingProps}
						isSimplified={shouldSimplifyCampusView}
					/>
				</div>
			);
		},

		render: function() {
			return (
				<LoadGuard
					identifier={`pageHome-${this.props.avatarChapterID}`}
					status={this.getAvatarChapterStatus()}
					requestLoad={this.loadAvatarChapter}
					errorView={"refresh"}
					loadingView={"logo"}
					logoColorType={"white"}
					renderLoaded={this.renderHome}
				/>
			);
		},
	})
);
